module.exports = __webpack_public_path__ + "static/media/proceso_de_gestión_de_acciones_correctivas_preventivas.d0281fd9.jpg";